import Joi from 'joi';

/**
 * Schema to validate status transitions for operations.
 *
 * 1. Cannot set a status if it is already that status.
 * 2. Can set status to 'cancelled' only if the current status is 'pending'.
 * 3. Can set status to 'in_progress' only if the current time is before 'endsAt'.
 * 4. Can set status to 'completed' only if the current time is after 'startsAt'.
 * 5. Can set status to 'pending' at any time (resets check-ins and check-outs).
 *
 * @param newStatus - The new status to validate against.
 * @param currentTime - The current timestamp.
 * @returns - The Joi schema for validation.
 */
export const setOperationStatusSchema = (newStatus: string) => {
	return Joi.object({
		status: Joi.string()
			.required()
			.custom((value, helpers) => {
				if (value === newStatus) {
					return helpers.error('any.sameStatus', { value });
				}
				if (newStatus === 'cancelled' && value !== 'pending') {
					return helpers.error('any.notPending', { value });
				}

				return value;
			})
			.messages({
				'any.sameStatus': `validations|set-status|already-${newStatus.toLowerCase()}`,
				'any.notPending': `validations|set-status|must-be-pending`,
				'any.required': 'validations|set-status|status-required',
			}),
	}).unknown(true);
};
